import { Id } from "@dgs/core";
import { AirportIndexResource } from "../../../../shared/types/airport";

export type TravelDirection = "arrival" | "departure";

export interface BaseTravelSegmentCar {
	identifier: string;
	type: "car";

	departureDate: string | null;
	departureTime: string | null;
	arrivalDate: string | null;
	arrivalTime: string | null;
	departureLocation: string;
	arrivalLocation: string;
	parkingSpot: string | null;
	chargingStation: string | null;
}

export interface TravelSegmentIndexCarResource extends BaseTravelSegmentCar {
	id: number;
	contingent: number | null;
	travelCount: number | null;
}

export interface BaseTravelSegmentTrain {
	identifier: string | null;
	additionalIdentifiers: string[];
	type: "train";

	departureLocation: string;
	arrivalLocation: string;
	departureDate: string;
	departureTime: string;
	arrivalDate: string;
	arrivalTime: string;
	serviceClass: string | null;
}

export interface TravelSegmentIndexTrainResource extends BaseTravelSegmentTrain {
	id: number;
	contingent: number | null;
	travelCount: number | null;
}

export interface BaseTravelSegmentFlight {
	identifier: string | null;
	additionalIdentifiers: string[];
	type: "flight";

	departureLocation: AirportIndexResource | null;
	arrivalLocation: AirportIndexResource | null;
	departureDate: string;
	departureTime: string;
	arrivalDate: string;
	arrivalTime: string;
	serviceClass: string | null;
}

export interface TravelSegmentIndexFlightResource extends BaseTravelSegmentFlight {
	id: number;
	contingent: number | null;
	travelCount: number | null;
}

export interface BaseTravelSegmentShuttle {
	identifier: string;
	type: "shuttle";

	departureLocation: string;
	arrivalLocation: string;
	departureDate: string;
	departureTime: string;
	arrivalDate: string;
	arrivalTime: string;
}

export interface TravelSegmentIndexShuttleResource extends BaseTravelSegmentShuttle {
	id: number;
	contingent: number | null;
	travelCount: number | null;
}

interface TravelSegmentTrainFormValues extends BaseTravelSegmentTrain {
	id: symbol;
}

interface TravelSegmentCarFormValues extends BaseTravelSegmentCar {
	id: symbol;
}

export interface TravelSegmentFlightFormValues extends BaseTravelSegmentFlight {
	id: symbol;
}
interface TravelSegmentFlightCreateRequest {
	identifier: string | null;
	type: "flight";

	departureLocation: string;
	arrivalLocation: string;
	departureDate: string;
	departureTime: string;
	arrivalDate: string;
	arrivalTime: string;
	serviceClass: string | null;
}

type TravelSegmentCarCreateRequest = BaseTravelSegmentCar;
type TravelSegmentTrainCreateRequest = BaseTravelSegmentTrain;

export type TravelSegmentCreateRequest =
	| TravelSegmentFlightCreateRequest
	| TravelSegmentCarCreateRequest
	| TravelSegmentTrainCreateRequest;

export type BaseTravelSegment =
	| BaseTravelSegmentCar
	| BaseTravelSegmentFlight
	| BaseTravelSegmentTrain
	| BaseTravelSegmentShuttle;

export type TravelSegmentFormValues =
	| TravelSegmentTrainFormValues
	| TravelSegmentCarFormValues
	| TravelSegmentFlightFormValues;

export type TravelSegmentIndexResource =
	| TravelSegmentIndexCarResource
	| TravelSegmentIndexTrainResource
	| TravelSegmentIndexFlightResource
	| TravelSegmentIndexShuttleResource;

export type TravelSegmentType = TravelSegmentIndexResource["type"];

export type SelectableTravelSegmentIndexResource =
	| TravelSegmentIndexTrainResource
	| TravelSegmentIndexFlightResource
	| TravelSegmentIndexCarResource
	| TravelSegmentIndexShuttleResource;
export type SelectableSegmentType = SelectableTravelSegmentIndexResource["type"];

export type AssignableTravelSegmentType = TravelSegmentType;

export interface TravelSegmentSearchRequest {
	search: string | null;
	type: TravelSegmentType | null;
	guestId: Id | null;
	withPublicScope: boolean;
}

export const isTravelSegmentIndexResource = (
	value: TravelSegmentIndexResource | TravelSegmentFormValues,
): value is TravelSegmentIndexResource => {
	return typeof value.id === "number";
};

export const isTravelSegmentFormValues = (
	value: TravelSegmentIndexResource | TravelSegmentFormValues,
): value is TravelSegmentFormValues => {
	return !isTravelSegmentIndexResource(value);
};
